import Sidebar from '../'

const subSidebar = (props) => <Sidebar id="sub-sidebar" {...props} />

export default subSidebar